/* eslint-disable */
/**
 * useDebouncedValue — return `value` after it has been stable for `delayMs`.
 *
 * Pattern: input/UI binds to the immediate state for responsiveness; only
 * the debounced output flows into queryKeys / network fetches / expensive
 * memos. Cancels pending updates on unmount and when `value` changes again.
 */
import { useEffect, useState } from "react";

export function useDebouncedValue(value, delayMs = 250) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
